export const OfferPriceMicrodata = ({price = 0}: {price?: number}) => (
  <div
    itemProp="offers"
    itemScope
    itemType="https://schema.org/Offer"
    className="visually-hidden"
  >
    <meta itemProp="price" content={`${price / 100}`} />
    <meta itemProp="priceCurrency" content="RUB" />
  </div>
);
